export default "__VITE_ASSET__DXkGNR0W__"